<template>
  <section>
    <el-form
      ref="occ-form"
      :rules="rules"
      :disabled="disabled"
      :model="formData">
      <h3 class="color-dark">Employee’s Compensation Details</h3>
      <div
        v-for="(occ,index) in formData.occ_detail_list"
        :key="index"
        class="card-border">
        <div
          class="flex-sb-center card-border__content mg-b-0"
        >
          <span
            v-if="index>0&&!disabled"
            class="color-del pointer text-left"
            @click="handlerDelOcc(index)"
          >Delete</span>
        </div>
        <div
          class="form-half">
          <div class="form-item ">
            <span >Occupation / Position</span>
            <el-form-item
              :ref="`occ_detail_list.${index}.occ_id`"
              :rules="isEdit?[]:rules.occ_id"
              :prop="`occ_detail_list.${index}.occ_id`">
              <v-select
                v-model="occ.occ_id"
                :block="true"
                :list="SMEJobRoleOption" />
            </el-form-item>
          </div>
        </div>
        <div class="flex-sb-center">
          <div
            v-for="(item,occIndex) in occ.occ_detail"
            :key="`occ_detail${occIndex}`"
            class="form-half bg-gray">
            <div class="form-item pd-b-0">
              <el-form-item
                v-if="!disabled"
                :ref="`occ_detail_list.${index}.occ_detail.nature_time_enable`"
                :rules="rules.nature_time_enable"
                :prop="`occ_detail_list.${index}.occ_detail.nature_time_enable`">
                <v-checkbox
                  v-model="item.nature_time_enable"
                  :is-boolean="false"
                  :noNumber="2">{{item.nature_time_nm}}</v-checkbox>
              </el-form-item>
              <span v-else>
                {{item.nature_time_nm}}
              </span>
            </div>
            <template v-if="item.nature_time_enable==1||disabled">
              <div class="form-item pd-t-16">
                <span>No. of Employee(s)</span>
                <el-form-item
                  :ref="`occ_detail_list.${index}.occ_detail.${occIndex}.no_of_employee`"
                  :rules="rules.no_of_employee"
                  :prop="`occ_detail_list.${index}.occ_detail.${occIndex}.no_of_employee`">
                  <v-input
                    v-model="item.no_of_employee"
                    :int="true"
                    :max="30"
                    :key-number="true"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Estimated Annual Earnings</span>
                <el-form-item
                  :ref="`occ_detail_list.${index}.occ_detail.${occIndex}.annual_salary`"
                  :rules="rules.annual_salary"
                  :prop="`occ_detail_list.${index}.occ_detail.${occIndex}.annual_salary`">
                  <v-input
                    v-model="item.annual_salary"
                    key-float-number
                    :key-non-chinese="true"
                  />
                </el-form-item>
              </div>
            </template>
          </div>
        </div>
      </div>

    </el-form>
    <template v-if="!disabled">
      <v-button
        blue
        icon="add"
        class="mg-b-15"
        @click="handlerAddOcc">Add Occupation</v-button>
    </template>
  </section>

</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {mapState} from 'vuex'
import {smeClassId} from '@/utils/smePath'

export default {
  name: 'occuptionForm',
  mixins: [MixinOptions, MixinRules],
  props:{
    form:{
      type:Object,
      default: ()=>({})
    },
    disabled:{
      type:Boolean,
      default:false
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    classId:{
      type:[String,Number],
      default:''
    },
  },
  data() {
    const checkOpen = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const occ_index = field_arr[3]
      const { occ_detail } = this.formData.occ_detail_list[index]
      const {nature_time_enable} = occ_detail[occ_index]||{}
      if(nature_time_enable&&!this.isEdit) {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        const require = this.isRequired && this.requireValid

        if(require && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        if(this.baseField.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      callback()
    }
    const checkEmployee = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const occ_index = field_arr[3]
      const { occ_detail } = this.formData.occ_detail_list[index]
      const {nature_time_enable} = occ_detail[occ_index]||{}
      if(nature_time_enable&&!this.isEdit) {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        const require = this.isRequired && this.requireValid
        if(require && !valueResult||value<=0) {
          callback(new Error(this.$t('placeholder.input')))
        }
        if(this.baseField.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      callback()
    }
    const checkSelect = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const { occ_detail } =this.formData.occ_detail_list[index]
      let check = occ_detail.find(item=>item.nature_time_enable==1)
      if(!check&&!this.isEdit) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }

    return {
      SMEJobRoleOption:[],
      formData:{
        occ_detail_list:[
          {
            occ_detail:{},
            occ_id:''
          },
        ]
      },
      rules:{
        nature_time_enable:[
          { validator: checkSelect, trigger: ['change','blur'] }
        ],
        no_of_employee:[
          { validator: checkEmployee, trigger: ['change', 'blur'] }
        ],
        annual_salary:[
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
    occDetailList(){
      let obj = {nature_time_enable:null,annual_salary:0,no_of_employee:0}
      let arr = [
        {nature_time:1,...obj,nature_time_nm:'Full Time'},
        {nature_time:2,...obj,nature_time_nm:'Part Time'}
      ]
      return arr
    },
    occObj(){
      return {
        occ_id:null,
        occ_detail:this.occDetailList
      }
    },
  },
  watch: {
    form:{
      immediate:true,
      deep:true,
      handler(val){
        const {occ_detail_list=[]} = JSON.parse(JSON.stringify(val||{}))
        if(occ_detail_list.length>0){
          let arr =  occ_detail_list.reduce((res,item)=>{
            item.occ_detail.filter(occ_item=>{
              if(occ_item.nature_time==1){
                occ_item.nature_time_nm = 'Full Time'
              }
              if(occ_item.nature_time==2){
                occ_item.nature_time_nm = 'Part Time'
              }
            })
            res.push(item)
            return res
          },[])
          this.formData.occ_detail_list	 = arr
        }
        else {
          this.formData.occ_detail_list=[{...this.occObj}]
        }
      }
    },
    classId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.SMEJobRoleOption = this[`SMEJobRoleOption_${val}`]
        }
      }
    }
  },
  methods:{
    handlerAddOcc(){
      let obj = JSON.parse(JSON.stringify(this.occObj))
      this.formData.occ_detail_list.push({...obj})
    },
    handlerDelOcc(index){
      this.formData.occ_detail_list.splice(index,1)
    },
    subimitLessForm(){
      return new Promise((resolve, reject) => {
        resolve(this.formData)
      })
    },
    submitForm(){
      return new Promise((resolve, reject) => {
        this.$refs['occ-form'].validate((valid, rules) => {
          if(valid){
            resolve(this.formData)
          }else
            this.scrollToValidDom(rules)
          reject()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card-border{
  border-radius: 5px;
  border: 1px solid #e1e4e8;
  padding: 15px;
  margin-bottom: 20px;
  position: relative;
  .card-border__content{
    margin-bottom: 20px;
    &.mg-b-0{
      margin-bottom: 0;
    }
    .card-border__title{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
      display: inline-block;
    }
    .text-left{
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }
  .flex-sb-center{
    flex-wrap: wrap;
    .bg-gray{
      margin-bottom: 20px;
      &:nth-last-child(2){
        margin-bottom: 0;
      }
      &:last-child{
        margin-bottom: 0;
      }
    }
  }

  .bg-gray{
    background: #F6F8FA;
    border-radius: 6px;
    padding: 15px;
    align-self: flex-start;
  }
}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #24292E;
  font-weight: 600;
}
/deep/.el-checkbox__label {
  color: #24292E;
  font-weight: 600;
}
</style>
